/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosAddressDetailInfo = {
    ADDR: string;
    ADDRT: AptosAddressDetailInfo.ADDRT;
    NM: string;
    BL: string;
    VAL: string;
    SEQNO: string;
    AUTHKEY: string;
};

export namespace AptosAddressDetailInfo {

    export enum ADDRT {
        EOA = 'EOA',
        CA = 'CA',
        OBJECT = 'OBJECT',
    }


}

